<div class="switch-button">
  <input class="switch-button-checkbox" type="checkbox" (change)="selectionChanged($event)" />
  <label class="switch-button-label" for=""
    ><span class="switch-button-label-span">{{ leftText }}</span></label
  >
</div>
